export const FETCH_SKILLS_REPORTS_SUCCESS = 'FETCH_SKILLS_REPORTS_SUCCESS';
export const FETCH_SKILLS_REPORTS_FAILURE=  'FETCH_SKILLS_REPORTS_FAILURE';
export const FETCH_USER_PENDING_SKILLS_SUCCESS_OUTLOOK ='FETCH_USER_PENDING_SKILLS_SUCCESS_OUTLOOK';
export const FETCH_USER_PENDING_SKILLS_FAILURE_OUTLOOK ='FETCH_USER_PENDING_SKILLS_FAILURE_OUTLOOK';

